module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-mf.a9192553.png";